import type {
  Email_Templates_Files_Insert_Input,
  Email_Templates_Insert_Input,
} from '@graphql/__generated__/graphql';
import type { EmailTemplateInput } from '@modules/_shared/components/EmailTemplateForm';

type EmailTemplateOwner = { developmentId: string } | { listingId: string };

type EmailTemplateType = 'buyers_auto_matching' | 'enquiry_auto_response';

export const createEmailTemplateMutationData = ({
  emailTemplateId,
  input,
  owner,
  type,
}: {
  emailTemplateId: string;
  input: EmailTemplateInput;
  owner: EmailTemplateOwner;
  type: EmailTemplateType;
}): {
  emailTemplate: Email_Templates_Insert_Input;
  files: Email_Templates_Files_Insert_Input[];
} => {
  const ownerReference =
    'listingId' in owner
      ? { lot_id: owner.listingId }
      : { development_id: owner.developmentId };

  return {
    emailTemplate: {
      id: emailTemplateId,
      name: input.name,
      subject: input.subject,
      subject_plaintext: input.subjectPlaintext,
      type,
      text: input.text,
      text_plaintext: input.textPlaintext,
      text_html: input.textHTML,
      add_signature: input.addSignature,
      is_shared_with_everyone: input.isSharedWithEveryone,
      is_shared_with_organisation: input.isSharedWithOrganisation,
      cc: input.cc,
      bcc: input.bcc,
      ...ownerReference,
    },
    files: input.files.map(({ id: _, ...file }) => ({
      email_template_id: emailTemplateId,
      file: { data: file },
    })),
  };
};
